export const sortLocalisedLanguages = (languages) => {
    const result = [...languages];
    result.sort((a, b) => a.text.localeCompare(b.text));
    return result;
};
export const localeSearchFilter = (input, option) => {
    if (option === undefined) {
        return false;
    }
    if (option.title === undefined) {
        return false;
    }
    return option.title.toLowerCase().indexOf(input.toLowerCase()) >= 0;
};
